/*!

 =========================================================
 * Vue Light Bootstrap Dashboard - v2.0.0 (Bootstrap 4)
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

import UUID from "vue-uuid";

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

Vue.use(UUID);
import axios from 'axios'
if (process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = 'https://api.dashboard.ceg.olx.org'
        // axios.defaults.baseURL = 'http://ec2-54-174-155-201.compute-1.amazonaws.com/'
} else {
    axios.defaults.baseURL = 'http://127.0.0.1:5000'
}

// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VCalendar from 'v-calendar';

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
    componentPrefix: 'vc', // Use <vc-calendar /> instead of <v-calendar />
});
import './registerServiceWorker'
// plugin setup
Vue.use(VueRouter)
Vue.use(LightBootstrap)
Vue.use(BootstrapVue)
Vue.config.silent = true;

// router setup
import routes from './routes/routes'

// configure router
const router = new VueRouter({
    mode: 'history',
    routes, // short for routes: routes
    linkActiveClass: 'nav-item active',
    scrollBehavior: (to) => {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    }
})

var store = {
    debug: true,
    state: {
        currentUser: ''
    },
    setUser(newValue) {
        if (this.debug) console.log('setUser triggered with', newValue)
        this.state.currentUser = newValue
    },
}

router.beforeEach(Vue.prototype.$auth.authRedirectGuard())

/* eslint-disable no-new */
new Vue({
    el: '#app',
    currentUser: null,
    render: h => h(App),
    router
})

Vue.prototype.$store = store
